import $ from 'jquery';

export const init = () => {

	$(document)
		.on('click', '.js-header', function(e) {
			e.preventDefault();

			var $this = $(this),
				$header = $this.closest('.header');

			$header.toggleClass('is-open');
		});

	$(window)
		.on('scroll', function() {
			if ( $(document).scrollTop() > 30 ) {
				$('.header').addClass('is-fixed');
			}
			else {
				$('.header').removeClass('is-fixed');
			}
		})
		.trigger('scroll');


};



// WEBPACK FOOTER //
// ./src/js/components/header.js